<!--
 * @Description: 登录
 * @Author: huangshiwen
 * @Date: 2022-05-30 13:40:58
 * @LastEditTime: 2022-06-08 16:21:51
-->
<template>
  <SzhospitalSignin />
</template>

<script>
import SzhospitalSignin from "@/components/hospitalSignin/szhospitalSignin"
export default{
  components:{
    SzhospitalSignin
  },
  
  data(){
    return {

    }
  },
  created(){

  }
}
</script>
<style lang="less" scoped>

</style>